function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#a1dbd3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2021",
  d: "M14.969 0H5.207a.651.651 0 00-.651.651v5.857h6.238l-2.6-2.6.92-.92 3.714 3.714a.651.651 0 010 .92l-3.714 3.714-.92-.92 2.6-2.6H4.556v5.857a.651.651 0 00.651.651h9.762a.651.651 0 00.651-.651V.651A.651.651 0 0014.969 0z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2022",
  d: "M0 6.508h4.556v1.3H0z"
}));
var SvgLogInSharp = function SvgLogInSharp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.619,
    height: 14.317
  }, props), _ref);
};
export default SvgLogInSharp;